import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import * as Yup from "yup";
import { useToast } from '../../../../../../../components/Toats';
import { putSettingsCompanyAll } from '../../../../../../../../services/settingsCompanyService';
import { getAuth, useAuth } from '../../../../../../../../modules/auth';
import { toAbsoluteUrl } from '../../../../../../../../../_metronic/helpers';
import { WhatsAppConnection, WhatsAppStatus, WhatsAppTemplates, WhatsAppSend } from '../whatsapp';
import { NuklieActivation } from '../../../../../../../components/Nuklie';

const validationSchema = Yup.object().shape({
    tokenSolarNext: Yup.string(),
  });

export function ConectionsCompany() {

    const [loading, setLoading] = useState<boolean>(false);
    const { toggleToast } = useToast();
    const [initialValues] = useState<any>({
        tokenSolarNext: null,
    })
    const { currentUser } = useAuth();
    const [showPassword, setShowPassword] = useState(false);
    const [activeWhatsAppTab, setActiveWhatsAppTab] = useState('connection');

    const auth = getAuth()

    const togglePasswordVisibility = () => {
      setShowPassword(!showPassword);
    };

    const updateSettingsCompany = async () => {
        try {
            setLoading(true)
            
            const body = {
                token_solar_next: formik.values.tokenSolarNext
            }

            await putSettingsCompanyAll(currentUser 
            && currentUser.companies && currentUser.companies.length > 0 
            && currentUser.companies[0].settingsCompany  ? currentUser.companies[0].settingsCompany.id : "", body)

            toggleToast("Sucesso ao atualizar preferências. ", "success")

    
            
        } catch (error) {
            console.log('erro',error)
            toggleToast("Erro ao atualizar preferências. ", "error")
            //toggleToast("Erro ao buscar os templates. ", "error")
        }finally{
            setLoading(false);
            setTimeout(()=>{
                window.location.reload()
            }, 700);
        }
    }

    // const getURLRedirectWhatsapp = useMutation(
    //     async () => {
    //       const response = await getURLRedirectConectMeta(
    //         currentUser &&
    //         currentUser.companies &&
    //         currentUser.companies.length > 0 &&
    //         currentUser.companies[0].id || ""
    //       );
    //       return response
    //     },
    //     {
    //       onSuccess: () => {
    //         //toggleToast("Solicitação adicionada a fila de processamento. Aguarde!", "info");
    //       },
    //       onError: () => {
    //         toggleToast("Erro ao adicionar solicitação a fila de processamento. Tente novamente!", "error");
    //       },
    //     }
    //   );

    // const { refetch: fetchRedirectUrl, isFetching: loadingURL } = useQuery<any>(
    //     [
    //       "getURLRedirectConectMeta",
    //       (currentUser &&
    //         currentUser.companies &&
    //         currentUser.companies.length > 0 &&
    //         currentUser.companies[0].id) ||
    //         "",
    //     ],
    //     async () => {
    //       const response = await getURLRedirectConectMeta(
    //         (currentUser &&
    //           currentUser.companies &&
    //           currentUser.companies.length > 0 &&
    //           currentUser.companies[0].id) ||
    //           ""
    //       );
      
    //       if (response && response.signup_url) {
    //         return response.signup_url;
    //       }
      
    //       return null;
    //     },
    //     {
    //       enabled: false,
    //       onError: (error) => {
    //         console.log(error);
    //         toggleToast("Erro ao buscar URL de redirecionamento!", "error");
    //       },
    //     }
    //   );

    //   const handleConnectWhatsApp = async () => {
    //     const result = await fetchRedirectUrl();
      
    //     if (result?.data) {
    //       window.location.assign(result.data);
    //       return;
    //     }
      
    //     toggleToast("URL de conexão não encontrada!", "error");
    //   };

    const submit = () => {
        updateSettingsCompany()
    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        validateOnChange: false,
        onSubmit: () => {},
    });


    useEffect(() => {
        if (
            currentUser 
            && currentUser.companies 
            && currentUser.companies.length > 0 
            && currentUser.companies[0].settingsCompany
            && currentUser.companies[0].settingsCompany.token_solar_next
        ) {
            formik.setValues({tokenSolarNext: currentUser.companies[0].settingsCompany.token_solar_next});
        }
    }, [currentUser])
    
      
  return (
    <div className='card mb-5 mb-xl-10' style={{}}>
        <div
            className='card-header border-0 cursor-pointer'
            role='button'
            data-bs-toggle='collapse'
            data-bs-target='#kt_account_profile_conections'
            aria-expanded='true'
            aria-controls='kt_account_profile_conections'
        >
            <div className='card-title m-0'>
                <h3 className='fw-bolder m-0'>Conexões Externas</h3>
            </div>
        </div>

        <div id='kt_account_profile_conections' className='collapse show'>
            <div className='card-body border-top p-9'>
                <div>
                    <div className='row mb-6'>
                        <div className='col-lg-4 col-form-label'>
                            {/* <label className='fw-bold fs-6'>Solar Next</label> */}
                            <img src="https://res.cloudinary.com/deq3ehxe3/image/upload/v1756238285/sn-lekko_oyaudm.png" alt="" width={150} />
                        </div>

                        <div className='col-lg-8 fv-row' style={{display: 'flex', gap: '0.5rem'}}>
                            <input
                                type={showPassword ? "text" : "password"}
                                className='form-control form-control-lg form-control-solid'
                                name='token_solar_next'
                                placeholder='Token de acesso'
                                value={formik.values.tokenSolarNext}
                                onChange={formik.handleChange("tokenSolarNext")}
                            />
                            <button
                                onClick={togglePasswordVisibility}
                                style={{height: 'auto'}}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            >
                                {/* <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' /> */}
                                <i className={`bi bi-eye-fill`} style={{fontSize: '1.2rem'}}></i>
                            </button>
                            {/* <input
                            type='text'
                            className='form-control form-control-lg form-control-solid'
                            placeholder='Token de acesso'
                            defaultValue={formik.values.tokenSolarNext}
                            onChange={formik.handleChange("tokenSolarNext")}
                            /> */}
                        </div>
                    </div>

                    <div className='row mb-6'>
                        <div className='col-lg-4 col-form-label'>
                            {/* <label className='fw-bold fs-6'>Solar Next</label> */}
                            <img src={toAbsoluteUrl('/media/imgs/novaLogoBlack.png')} alt="" width={180} />
                        </div>

                        <div className='col-lg-8 fv-row' style={{display: 'flex', gap: '0.5rem'}}>
                            <input
                                type={showPassword ? "text" : "password"}
                                className='form-control form-control-lg form-control-solid'
                                name='token_solar_vision'
                                placeholder='Token de acesso'
                                value={auth?.api_token}
                                disabled
                                //onChange={formik.handleChange("tokenSolarNext")}
                            />
                            <button
                                onClick={togglePasswordVisibility}
                                style={{height: 'auto'}}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            >
                                {/* <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' /> */}
                                <i className={`bi bi-eye-fill`} style={{fontSize: '1.2rem'}}></i>
                            </button>
                        </div>
                    </div>

                    <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                        <button onClick={submit} className='btn btn-primary'>
                            {!loading && 'Salvar Token'}
                            {loading && (
                            <span className='indicator-progress' style={{display: 'block'}}>
                                Aguarde...{' '}
                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                            </span>
                            )}
                        </button>
                    </div>

                    
                </div>

                <div className='separator separator-dashed my-6'></div>

                {currentUser?.role?.slug === 'EMPRESA' && (
                    <>
                        <NuklieActivation />
                        <div className='separator separator-dashed my-6'></div>
                    </>
                )}

                {currentUser?.companies?.[0]?.settingsCompany?.liberar_whatsapp && 
                    <div>
                        <div className='d-flex align-items-center mb-4'>
                            <img src={toAbsoluteUrl('/media/imgs/whatsapp-business.png')} alt="" width={200} className="me-3" />
                            {/* <h4 className='mb-0'>Integração WhatsApp</h4> */}
                        </div>

                        <ul className="nav nav-tabs nav-line-tabs mb-5 fs-6 fw-semibold">
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeWhatsAppTab === 'connection' ? 'active text-active-primary'  : ''}`}
                                    onClick={() => setActiveWhatsAppTab('connection')}
                                >
                                    Conexão
                                </button>
                            </li>
                            {/* <li className="nav-item">
                                <button
                                    className={`nav-link ${activeWhatsAppTab === 'status' ? 'active text-active-primary ' : ''}`}
                                    onClick={() => setActiveWhatsAppTab('status')}
                                >
                                    Status
                                </button>
                            </li> */}
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeWhatsAppTab === 'templates' ? 'active text-active-primary ' : ''}`}
                                    onClick={() => setActiveWhatsAppTab('templates')}
                                >
                                    Templates
                                </button>
                            </li>
                            {/* <li className="nav-item">
                                <button
                                    className={`nav-link ${activeWhatsAppTab === 'send' ? 'active text-active-primary ' : ''}`}
                                    onClick={() => setActiveWhatsAppTab('send')}
                                >
                                    Enviar
                                </button>
                            </li> */}
                        </ul>

                        <div className="tab-content">
                            {activeWhatsAppTab === 'connection' && (
                                <WhatsAppConnection
                                    companyId={currentUser?.companies?.[0]?.id || ''}
                                />
                            )}

                            {activeWhatsAppTab === 'templates' && (
                                <WhatsAppTemplates
                                    companyId={currentUser?.companies?.[0]?.id || ''}
                                />
                            )}
                            {activeWhatsAppTab === 'send' && (
                                <WhatsAppSend
                                    companyId={currentUser?.companies?.[0]?.id || ''}
                                />
                            )}
                        </div>
                    </div>
                }
                    
                {/* <div className='card-footer d-flex justify-content-end py-6 px-9'>
                    
                </div> */}
            </div>
        </div>
    </div>
  );
}